import { memo } from "react";

function IconLogo() {
  return (
    <svg
      width="99"
      height="26"
      viewBox="0 0 99 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_196_299)">
        <path
          d="M85.3585 23.6671L82.9089 19.4813C82.5835 18.9253 82.9845 18.2261 83.6286 18.2261H88.528C89.1722 18.2261 89.5731 18.9253 89.2478 19.4813L86.798 23.6671C86.476 24.2174 85.6806 24.2174 85.3585 23.6671Z"
          fill="#00C7B1"
        />
        <path
          d="M69.8723 9.15527e-05C69.6255 9.15527e-05 69.4062 0.157492 69.3274 0.391392L62.8963 19.4561C62.6922 20.061 62.202 20.1514 61.9279 20.1514C61.6536 20.1514 61.1634 20.0612 60.9593 19.4561L54.5263 0.391292C54.4474 0.157492 54.2281 9.15527e-05 53.9813 9.15527e-05H49.4977C49.1042 9.15527e-05 48.827 0.386292 48.9528 0.759092L55.8443 21.182C56.9691 24.5159 60.4506 26.3675 64.1456 25.1981C65.94 24.6304 67.3311 23.1984 67.9327 21.4151L74.9005 0.759092C75.0262 0.386192 74.749 9.15527e-05 74.3555 9.15527e-05H69.8723Z"
          fill="#041C2C"
        />
        <path
          d="M78.1829 25.4509C78.4297 25.4509 78.649 25.2934 78.7278 25.0596L85.0923 6.19243C85.2964 5.58723 85.7867 5.49693 86.0608 5.49693C86.3349 5.49693 86.8252 5.58723 87.0293 6.19243L93.396 25.0596C93.4749 25.2935 93.6942 25.4509 93.941 25.4509H98.4244C98.8179 25.4509 99.0952 25.0647 98.9693 24.6918L92.1443 4.46623C91.249 1.81283 88.8609 0.0984328 86.0606 0.0986328C83.2601 0.0988328 80.8724 1.81343 79.9772 4.46703L73.1547 24.6919C73.0289 25.0647 73.3062 25.4509 73.6997 25.4509H78.1829Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 5.1152H27.1329C26.8145 5.1152 26.5564 4.8571 26.5564 4.5387V0.5764C26.5564 0.2581 26.8145 0 27.1329 0H44.3693C44.6881 0 44.9467 0.2585 44.9467 0.5773V4.5379C44.9467 4.8567 44.6881 5.1152 44.3693 5.1152Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 25.5493H27.1329C26.8145 25.5493 26.5564 25.2912 26.5564 24.9728V21.0105C26.5564 20.6922 26.8145 20.4341 27.1329 20.4341H44.3693C44.6881 20.4341 44.9467 20.6926 44.9467 21.0114V24.972C44.9467 25.2908 44.6881 25.5493 44.3693 25.5493Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 15.3325H27.1329C26.8145 15.3325 26.5564 15.0744 26.5564 14.756V10.7937C26.5564 10.4754 26.8145 10.2173 27.1329 10.2173H44.3693C44.6881 10.2173 44.9467 10.4758 44.9467 10.7946V14.7552C44.9467 15.074 44.6881 15.3325 44.3693 15.3325Z"
          fill="#041C2C"
        />
        <path
          d="M0 0.749999C0 0.335786 0.335786 0 0.75 0H13.5776C15.7919 0 17.5682 0.59615 18.9065 1.78845C20.2691 2.98075 20.9504 4.55021 20.9504 6.49682V9.05175C20.9504 10.317 20.5854 11.4242 19.8554 12.3732C19.1565 13.2889 18.1354 13.9899 16.7921 14.4761C16.7688 14.4845 16.753 14.5066 16.753 14.5314C16.753 14.5512 16.7631 14.5697 16.7795 14.5806C17.5449 15.0874 18.1201 15.6655 18.505 16.315C18.9186 16.972 19.3201 17.8845 19.7094 19.0525L21.4466 24.5742C21.5987 25.0574 21.2378 25.5493 20.7312 25.5493H17.0819C16.7555 25.5493 16.4667 25.3383 16.3674 25.0274L14.5996 19.4905C14.2833 18.4442 13.8453 17.6655 13.2856 17.1545C12.726 16.6435 12.0325 16.388 11.2052 16.388H5.78686C5.37265 16.388 5.03686 16.7238 5.03686 17.138V24.7993C5.03686 25.2135 4.70107 25.5493 4.28686 25.5493H0.749999C0.335785 25.5493 0 25.2135 0 24.7993V0.749999ZM12.6286 12.0447C13.6506 12.0447 14.4536 11.777 15.0376 11.2417C15.6216 10.682 15.9136 9.96422 15.9136 9.08825V6.71581C15.9136 6.01017 15.6946 5.45052 15.2566 5.03686C14.8186 4.59887 14.2346 4.37988 13.5046 4.37988H5.78686C5.37264 4.37988 5.03686 4.71567 5.03686 5.12988V11.2947C5.03686 11.7089 5.37265 12.0447 5.78686 12.0447H12.6286Z"
          fill="url(#paint0_linear_196_299)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_196_299"
          x1="0"
          y1="12.7746"
          x2="21.7534"
          y2="12.7746"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00C7B1" />
          <stop offset="1" stopColor="#041C2C" />
        </linearGradient>
        <clipPath id="clip0_196_299">
          <rect width="99" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(IconLogo);
